<template>
	<page>
		<module enable-flex>
			<c-table ref="list" height="grow" :paging="false">
                <c-table-column label="渠道图标" name="icon_url" width="80">
                    <template #default="{data}">
                        <c-file v-if="data.icon_url" :src="data.icon_url" media class="channel-icon"></c-file>
                        <span v-else>未设置</span>
                    </template>
                </c-table-column>
				<c-table-column
					label="渠道名称"
					name="channel_name"
					width="100"
                    fixed="left"
                >
				</c-table-column>

				<c-table-column
					label="所属平台"
					name="platform_name"
					width="100"
				>
				</c-table-column>

				<!-- 是否启用 -->
				<c-table-column
					label="渠道类型"
					name="is_dark_auction"
					width="80"
                >
					<template #default="{data}">
                        <span v-if="data.is_dark_auction == 1"  style="color: red">暗拍</span>
                        <span v-if="data.is_dark_auction == 2"  style="color: green">靓机</span>
					</template>
				</c-table-column>

				<c-table-column
					label="渠道归属"
					name="owner_type"
					width="80"
                >
					<template #default="{data}">
                        <span v-if="data.owner_type == 1"  style="color: red">自营</span>
                        <span v-if="data.owner_type == 2"  style="color: green">三方</span>
                        <span v-if="data.owner_type == 3"  style="color: blue">线下</span>
					</template>
				</c-table-column>

                <c-table-column
					label="业务类型"
					name="biz_type"
					width="80"
                >
					<template #default="{data}">
                        <span v-if="data.biz_type == 1"  style="color: red">2B</span>
                        <span v-if="data.biz_type == 2"  style="color: green">2C</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="渠道描述"
                        name="phone"
                        width="120"
                ></c-table-column>

				<!-- 是否启用 -->
				<c-table-column
					label="状态"
					name="state"
					width="80"
                    fixed="right"
                >
					<template #default="{data}">
						<c-switch v-if="auth('b_channel_info_state')" v-model="data.status" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="280"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_channel_info_config')" icon="tf-setting" @click="channelIconEdit(data)">配置图标</c-table-button>
						<c-table-button v-if="auth('b_channel_info_config')" icon="tf-setting" @click="channelConfig(data)">配置结算公式</c-table-button>
						<c-table-button v-if="auth('b_channel_account_authorization') && data.owner_type == 2" icon="tf-accept" @click="channelAuthorization(data)">渠道账号授权</c-table-button>
                    </template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

    export default {
		components: {
        },

		computed: {
			// 获取dictName选项数据
			...mapState(['disableEnableDic']),
		},

		data() {
			return {
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
            channelIconEdit(data) {
                this.globalDialog('channelIconEdit', {data}, () => {
                    this.$refs.list.update();
                });
            },
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/channel/list',
					data
				});
			},
            /*********阶梯价配置**********/
            channelConfig(data) {
                this.globalDialog('channelConfig', {data: data}, () => {
                    this.$refs.list.update();
                });
            },
			/******用户启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/channel/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: () => {
                        this.$message({
                            message: '操作成功',  // 提示内容,
                            type: 'success'
                        });
						next();
					}
				})
			},
			/*******渠道授权弹框*******/
			channelAuthorization(data) {
				this.globalDialog('channelAuthorization', {data: data}, () => {
					this.$refs.list.update();
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
.channel-icon
    width 40px
    height 40px
    /deep/ img
        width 100%
        height 100%
        object-fit contain
</style>
